"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Meta = exports.MenuContentPlaceholder = exports.Main = exports.HeaderContentPlaceholder = exports.Content = exports.Container = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../../constants");
var _ContentPlaceholder = _interopRequireDefault(require("../../../components/ContentPlaceholder"));
var _styles = require("../../../components/ContentPlaceholder/styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Meta = exports.Meta = _styledComponents.default.div.withConfig({
  displayName: "styles__Meta",
  componentId: "sc-1pzcdjb-0"
})(["position:relative;height:100%;display:flex;flex-direction:column;"]);
const Main = exports.Main = _styledComponents.default.div.withConfig({
  displayName: "styles__Main",
  componentId: "sc-1pzcdjb-1"
})(["display:flex;flex-direction:row;min-width:768px;height:100%;position:relative;overflow:hidden;"]);
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1pzcdjb-2"
})(["flex:1;display:flex;flex-direction:column;justify-content:space-between;height:100%;position:relative;overflow:hidden;"]);
const Content = exports.Content = _styledComponents.default.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1pzcdjb-3"
})(["flex:1;overflow:auto;padding-left:", ";transition:padding-left 0.3s ease-in-out;z-index:100;position:relative;", ";", ";", ";", ";"], ({
  theme
}) => theme.AppFrame.menu.expandedWidth, ({
  collapsed,
  theme
}) => collapsed && (0, _styledComponents.css)(["padding-left:", ";"], theme.AppFrame.menu.collapsedWidth), ({
  withoutMenu
}) => withoutMenu && (0, _styledComponents.css)(["padding-left:0;"]), ({
  hiddenMenu,
  collapsed,
  theme
}) => hiddenMenu && (0, _styledComponents.css)(["padding-left:", ";transition:padding-left 0.3s ease-in-out;", ";"], theme.AppFrame.menu.expandedWidth, collapsed && (0, _styledComponents.css)(["padding-left:0;"])), ({
  theme
}) => theme.name === _constants.THEMES.mds && (0, _styledComponents.css)(["display:flex;flex-direction:column;"]));
const HeaderContentPlaceholder = exports.HeaderContentPlaceholder = (0, _styledComponents.default)(_ContentPlaceholder.default).withConfig({
  displayName: "styles__HeaderContentPlaceholder",
  componentId: "sc-1pzcdjb-4"
})(["", "{background-color:", ";background-image:linear-gradient( 90deg,", ",", ",", " );}"], _styles.Placeholder, ({
  theme
}) => theme.colors.appFrame.shimmer.placeholder.header.bg, ({
  theme
}) => theme.colors.appFrame.shimmer.placeholder.header.bg, ({
  theme
}) => theme.colors.appFrame.shimmer.placeholder.header.tint, ({
  theme
}) => theme.colors.appFrame.shimmer.placeholder.header.bg);
const MenuContentPlaceholder = exports.MenuContentPlaceholder = (0, _styledComponents.default)(_ContentPlaceholder.default).withConfig({
  displayName: "styles__MenuContentPlaceholder",
  componentId: "sc-1pzcdjb-5"
})(["", "{background-color:", ";background-image:linear-gradient( 90deg,", ",", ",", " );}"], _styles.Placeholder, ({
  theme
}) => theme.colors.appFrame.shimmer.placeholder.menu.bg, ({
  theme
}) => theme.colors.appFrame.shimmer.placeholder.menu.bg, ({
  theme
}) => theme.colors.appFrame.shimmer.placeholder.menu.tint, ({
  theme
}) => theme.colors.appFrame.shimmer.placeholder.menu.bg);